import React, { Component } from "react";
import axios from "axios";
import { checkCookie, getCookie } from "../Utils/Utils";
import { Navigate } from "react-router-dom";
import { BOOTH_USER_API, USER_API, TOKEN_API } from "../../constants/Constants";
import { Html5Qrcode } from "html5-qrcode";
import { Container, Form, Alert, Button, Row, Card } from "react-bootstrap";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

require("./Home.scss");

class Home extends Component {
  componentDidMount() {
    if (!checkCookie("boothUserId")) {
      this.setState({ redirect: true });
    } else {
      let url = BOOTH_USER_API + getCookie("boothUserId");
      axios.get(url).then(response => {
        this.setState({ user: response.data });
      });
    }

    let tokenDetails = this.state.tokenDetails;
    tokenDetails.boothId = getCookie("boothId");
    this.setState({ tokenDetails });
    console.log("Token Details")
    console.log(tokenDetails);
  }

  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      user: "",
      userDetails: null,
      tokenDetails: {
        boothId: "",
        userId: "",
        type: "IN-PERSON ORDER",
        tokens: 0
      },
      disabled: false,
      searchUser: "",
      searchView: false
    };

    this.updateSearchText = this.updateSearchText.bind(this);
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.setTokenValue = this.setTokenValue.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleScan = this.handleScan.bind(this);
    
    

    this.openSearch = this.openSearch.bind(this);
  }

  openSearch(searchOption) {
    console.log("Search Option: " + searchOption);
    this.clearUserDetails();
    if(searchOption === "qr-scanner") {
      this.setState({ searchView: false });
      this.handleScan();
    } else {
      this.closehtml5QrCode();
      this.setState({ searchView: true });
    }    
  }

  updateSearchText(e) {
    let userId = "USER" + e.target.value;
    this.setState({ searchUser: userId });
  }
  
  handleScan() {
    console.log("Inside handle Scan");
    this.html5QrCode = new Html5Qrcode("qr-reader");
    const qrCodeSuccessCallback = (decodedText, decodedResult) => {
      console.log("Scanned result:", decodedText);
      if (decodedText.startsWith("http")) {
        const urlParams = new URLSearchParams(decodedText.split("?")[1]);
        const userId = urlParams.get("userId");
        this.requestSearch(userId);
        this.closehtml5QrCode();
      } else {
        alert("Scanned text is not a valid URL: " + decodedText);
      }
    };


    this.html5QrCode.start(
      { facingMode: "environment" }, // Use the back camera by default
      {
        fps: 10,    // Frame rate for scanning
        qrbox: 350, // Size of the scanning box
      },
      qrCodeSuccessCallback
    ).then(() => {
      this.setState({ scanning: true });
    }).catch(err => {
      console.error("Error starting scanner:", err);
    });
    
  }

  handleSearchSubmit(e) {
    this.requestSearch(this.state.searchUser);
  }

  clearUserDetails() {
    this.setState({
      tokenDetails: {
        boothId: "",
        userId: "",
        type: "IN-PERSON ORDER",
        tokens: 0
      },
      userDetails: null
    });
  }

  closehtml5QrCode() {
    if (this.html5QrCode?.isScanning) {
      this.html5QrCode.stop().catch(err => console.error("Error stopping scanner:", err));
    }
  }

  requestSearch(searchUser) {
    
    let url = USER_API + searchUser;
    axios.get(url).then(response => {
      this.setState({ userDetails: response.data.userDetails });
      this.setState({ searchView: false });
    });

  }

  setTokenValue(e) {
    let tokenDetails = this.state.tokenDetails;
    tokenDetails.tokens = e.target.value;
    this.setState({ tokenDetails });
  }

  handleFormSubmit(e) {
    e.preventDefault();
    this.setState({ disabled: true });
    let tokenDetails = this.state.tokenDetails;
    tokenDetails.boothId = getCookie("boothId");
    tokenDetails.userId = this.state.userDetails.userId;
    if (tokenDetails.tokens > 0) {
      axios
        .post(TOKEN_API, tokenDetails, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          alert("Transaction Successful!");
          this.setState({ disabled: false });
          this.clearUserDetails();
        });
    }
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to="/authenticate" />;
    }
    const user = this.state.user;
    const userDetails = this.state.userDetails;
    return (
      <Container className="home-container">
        <Alert className="logged-user" key="primary" variant="primary">
          <u>{user.boothId} </u><br />
          {user.firstName} {user.lastName}
        </Alert>
        <Button className="search-button" onClick={() => { this.openSearch('qr-scanner'); }}>
            <QrCodeScannerIcon /> Scan QR
          </Button>
          <Button className="search-button" onClick={() => { this.openSearch('search-text'); }}>
            <PersonSearchIcon /> Search
          </Button>
        {this.state.searchView ? (
          <Form className="d-flex search-field">
            <Form.Control
              type="search"
              placeholder="Search"
              className="me-2"
              aria-label="Enter User Id"
              onChange={this.updateSearchText}
            ></Form.Control>
            <Button variant="outline-primary" onClick={this.handleSearchSubmit}>
              <SearchOutlinedIcon />
            </Button>
          </Form>
        ) : (
          ""
        )}
        <div id="qr-reader"/>
        <Row className="find-results">
          {this.state.userDetails !== null && (
            <Card>
              <Card.Title className="card-title">User Information</Card.Title>
              <Card.Text className="card-text">
                Name : {userDetails.firstName + " " + userDetails.lastName}
              </Card.Text>
              <Card.Text className="card-text">
                Contact Number : {userDetails.contactNumber}
              </Card.Text>
              <div className="spacer" />
              <Card.Title className="card-title">Order Information</Card.Title>
              <Card.Text className="card-text">
                Number of tokens :{" "}
                <input
                  type="number"
                  onChange={this.setTokenValue}
                  value={this.state.tokenDetails.tokens}
                ></input>
              </Card.Text>
              <Button
                className="order-submit"
                onClick={this.handleFormSubmit}
                disabled={this.state.disabled}
              >
                Submit
              </Button>
            </Card>
          )}
        </Row>
      </Container>
    );
  }
}

export default Home;
